export default "__VITE_ASSET__4df5c9cf__"